/* FS Shapes Guide
   Added: 2026-05-30
   Comportamento da section fs-shapes-guide: filtro por largura, expand de medidas,
   modal de detalhe com galeria (touch/drag/trackpad), tabs e navegação entre models.
   Auto-inicializa cada instância pelo root .fs-shapes-guide (defer + externo, sem Liquid). */

(function () {
  'use strict';

  /**
   * Inicializa uma instância da section.
   * @param {HTMLElement} sectionEl - root .fs-shapes-guide[data-section-id]
   */
  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.fsGuideInit === 'true') return;
    sectionEl.dataset.fsGuideInit = 'true';

    /* ── Coleta todos os dados dos blocos ── */
    var allModels = [];
    sectionEl.querySelectorAll('script[id^="fs-model-data-"]').forEach(function (el) {
      try { allModels.push(JSON.parse(el.textContent)); } catch (e) {}
    });

    /* ── Config do botão CTA (nível section) ──
       Classe/texto/seta vêm dos settings da section via data-* (montados no Liquid
       espelhando o snippet 'button'). Assim o CTA em runtime usa as mesmas opções
       nativas de cor/estilo/tamanho do tema. */
    var ctaClass = sectionEl.getAttribute('data-cta-class') || 'btn btn--solid btn--primary';
    var ctaText  = sectionEl.getAttribute('data-cta-text') || 'Ver shapes disponíveis';
    var ctaArrow = sectionEl.getAttribute('data-cta-arrow') === 'true';
    /* Marcação da seta nativa, capturada de um ícone já presente no DOM da section
       (evita hardcodar SVG). Fallback: string vazia. */
    var arrowEl  = sectionEl.querySelector('[data-modal-next] .icon-nav-arrow-right, .icon-nav-arrow-right');
    var ctaArrowHtml = ctaArrow && arrowEl ? arrowEl.outerHTML : '';

    /* ── Título collapsible ── */
    var toggleBtn = sectionEl.querySelector('[data-guide-toggle]');
    var introEl   = sectionEl.querySelector('[data-guide-intro]');
    if (toggleBtn && introEl) {
      toggleBtn.addEventListener('click', function () {
        var open = toggleBtn.getAttribute('aria-expanded') === 'true';
        toggleBtn.setAttribute('aria-expanded', String(!open));
        introEl.classList.toggle('is-open', !open);
      });
    }

    /* ── Filtro ── */
    var filterBtns = sectionEl.querySelectorAll('[data-filter]');
    var cards      = sectionEl.querySelectorAll('.fs-shapes-guide__card');

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = btn.getAttribute('data-filter');
        activeFilter = filter;
        filterBtns.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', String(b === btn));
        });
        cards.forEach(function (card) {
          var match = filter === 'all' || card.getAttribute('data-width') === filter;
          card.classList.toggle('is-hidden', !match);
        });
      });
    });

    /* ── Progress bar da barra de filtro (mobile) ──
       Espelha o scroll horizontal da nav num bar próprio (track cinza + thumb preto).
       O thumb tem largura proporcional ao quanto é visível e desliza conforme o scroll.
       Só aparece quando há overflow (.is-visible); o CSS o esconde fora do mobile. */
    var filterNav      = sectionEl.querySelector('.fs-shapes-guide__filter-nav');
    var filterProgress = sectionEl.querySelector('[data-filter-progress]');
    var filterThumb    = sectionEl.querySelector('[data-filter-progress-thumb]');

    /* Encurta o thumb à metade do comprimento proporcional (pedido de design) — fica como
       um "handle" curto, não uma barra que cobre quase todo o track. O mapeamento de
       posição/drag usa esse mesmo valor, então continua coerente. */
    var THUMB_SCALE = 0.5;

    function updateFilterProgress() {
      if (!filterNav || !filterProgress || !filterThumb) return;
      var sw = filterNav.scrollWidth;
      var cw = filterNav.clientWidth;
      /* +1 de tolerância para arredondamento de subpixel */
      if (sw <= cw + 1) {
        filterProgress.classList.remove('is-visible');
        return;
      }
      filterProgress.classList.add('is-visible');
      var widthPct = (cw / sw) * 100 * THUMB_SCALE;          /* fração visível → largura */
      var leftPct  = (filterNav.scrollLeft / (sw - cw)) * (100 - widthPct); /* posição */
      filterThumb.style.width = widthPct + '%';
      filterThumb.style.left  = leftPct + '%';
    }

    /* Drag do thumb para rolar a nav (Pointer Events — cobre touch/mouse, inclusive iOS).
       Converte o deslocamento do thumb dentro do track (trackW - thumbW) na faixa de scroll
       da nav (scrollWidth - clientWidth). Ao setar scrollLeft, o handler de 'scroll' já
       reposiciona o thumb — não precisamos atualizá-lo aqui. */
    function bindThumbDrag() {
      if (!filterNav || !filterProgress || !filterThumb) return;
      var dragging = false, startX = 0, startScroll = 0;

      filterThumb.addEventListener('pointerdown', function (e) {
        dragging = true;
        startX = e.clientX;
        startScroll = filterNav.scrollLeft;
        try { filterThumb.setPointerCapture(e.pointerId); } catch (err) {}
        e.preventDefault();
      });
      filterThumb.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var travel = filterProgress.clientWidth - filterThumb.offsetWidth;
        if (travel <= 0) return;
        var scrollRange = filterNav.scrollWidth - filterNav.clientWidth;
        filterNav.scrollLeft = startScroll + ((e.clientX - startX) / travel) * scrollRange;
      });
      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        try { filterThumb.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      filterThumb.addEventListener('pointerup', endDrag);
      filterThumb.addEventListener('pointercancel', endDrag);
    }

    if (filterNav) {
      filterNav.addEventListener('scroll', updateFilterProgress, { passive: true });
      window.addEventListener('resize', updateFilterProgress);
      bindThumbDrag();
      updateFilterProgress();
    }

    /* ── Expandir medidas (+/-) ── */
    sectionEl.querySelectorAll('[data-plus-btn]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var id   = btn.getAttribute('data-plus-btn');
        var box  = sectionEl.querySelector('#measurements-' + id);
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        box && box.classList.toggle('is-open', !open);
      });
    });

    /* ── Modal ── */
    var modal        = sectionEl.querySelector('[data-modal]');
    var modalSlides  = sectionEl.querySelector('[data-modal-slides]');
    var modalDots    = sectionEl.querySelector('[data-modal-dots]');
    var modalTitle   = sectionEl.querySelector('[data-modal-title]');
    var modalMeas    = sectionEl.querySelector('[data-modal-measurements]');
    var modalTabs    = sectionEl.querySelector('[data-modal-tabs]');
    var modalCta     = sectionEl.querySelector('[data-modal-cta]');
    var modalPrev    = sectionEl.querySelector('[data-modal-prev]');
    var modalNext    = sectionEl.querySelector('[data-modal-next]');
    /* Elementos que rolam: no desktop é a coluna de info; no mobile é o painel inteiro.
       Guardamos os dois para resetar o scroll ao topo a cada troca de model. */
    var modalInfo    = sectionEl.querySelector('.fs-shapes-modal__info');
    var modalPanel   = sectionEl.querySelector('.fs-shapes-modal__panel');

    var currentIndex  = 0;
    var currentSlide  = 0;
    var activeFilter  = 'all';
    var autoplayTimer = null;
    var currentAutoplayMs = 4000;
    /* Elemento que abriu o modal — foco retorna a ele ao fechar (a11y). */
    var lastFocused   = null;

    function visibleModels() {
      return allModels.filter(function (m) {
        return activeFilter === 'all' || m.width === activeFilter;
      });
    }

    function buildTabs(data) {
      var tabs = [];
      for (var i = 1; i <= 3; i++) {
        var t = data['tab_' + i + '_title'];
        var c = data['tab_' + i + '_content'];
        if (t && c) tabs.push({ title: t, content: c });
      }
      if (!tabs.length) return '';

      var links = tabs.map(function (tab, idx) {
        var sel = idx === 0;
        return '<li class="tab-link tab-link-' + idx + (sel ? ' current' : '') +
          '" data-tab="' + idx + '" role="tab" tabindex="' + (sel ? '0' : '-1') +
          '" aria-selected="' + sel + '" aria-controls="fs-tabpanel-' + idx +
          '" id="fs-tab-' + idx + '"><span>' + tab.title + '</span></li>';
      }).join('');

      var contents = tabs.map(function (tab, idx) {
        var sel = idx === 0;
        return '<div class="tab-content tab-content-' + idx + (sel ? ' current' : '') +
          ' rte" role="tabpanel" id="fs-tabpanel-' + idx + '" aria-labelledby="fs-tab-' +
          idx + '"' + (sel ? '' : ' hidden') + '>' + tab.content + '</div>';
      }).join('');

      return '<div class="fs-modal-tabs"><ul class="tabs" role="tablist">' + links + '</ul>' + contents + '</div>';
    }

    function buildCta(data) {
      if (!data.collection_url) return '';
      /* Estados sem produto: mesmo botão do CTA (classe/estilo/tamanho/fonte da section),
         porém desabilitado e sem clique — espelha o botão "Acabou" nativo do tema
         (<button disabled>). Sem seta, pois não é uma ação. */
      if (data.availability === 'out_of_stock' || data.availability === 'coming_soon') {
        var disabledText = data.availability === 'coming_soon' ? 'Em breve' : 'No momento indisponível';
        return '<button type="button" class="' + ctaClass + '" disabled aria-disabled="true">' +
               '<span>' + disabledText + '</span></button>';
      }
      /* Gerado em runtime, então não dá para usar o snippet 'button' (Liquid).
         A classe/texto/seta vêm dos settings da section (data-cta-*), espelhando o
         output do snippet 'button' (btn + style + size + type, <span> + ícone de seta),
         garantindo herança de cor (scheme), radius e estados do tema. */
      return '<a href="' + data.collection_url + '" class="' + ctaClass + '">' +
             '<span>' + ctaText + '</span>' + ctaArrowHtml + '</a>';
    }

    function buildMeasurements(data) {
      var pairs = [
        ['Largura', data.dim_width],
        ['Comprimento', data.dim_length],
        ['Wheelbase', data.dim_wheelbase],
        ['Nose', data.dim_nose],
        ['Tail', data.dim_tail]
      ];
      return pairs.filter(function (p) { return p[1]; }).map(function (p) {
        return '<li>' + p[0] + ': ' + p[1] + '</li>';
      }).join('');
    }

    function renderSlides(images, name) {
      currentSlide = 0;
      var imgs = images.filter(Boolean);
      if (!imgs.length) {
        modalSlides.innerHTML = '';
        modalDots.innerHTML   = '';
        return;
      }
      var label = name || '';
      modalSlides.innerHTML = imgs.map(function (src, i) {
        /* alt descritivo (a11y/SEO): nome do model + número da imagem quando há mais de uma */
        var alt = imgs.length > 1 ? label + ' — imagem ' + (i + 1) : label;
        return '<div class="fs-shapes-modal__slide"><img src="' + src + '" alt="' + alt + '" loading="lazy"></div>';
      }).join('');
      modalDots.innerHTML = imgs.length > 1 ? imgs.map(function (_, i) {
        return '<button class="flickity-page-dot' + (i === 0 ? ' is-selected' : '') + '" data-dot="' + i + '" aria-label="Imagem ' + (i + 1) + '"></button>';
      }).join('') : '';
      modalDots.querySelectorAll('[data-dot]').forEach(function (dot) {
        dot.addEventListener('click', function () { goSlide(parseInt(dot.getAttribute('data-dot'))); });
      });
    }

    var galleryPrevBtn = sectionEl.querySelector('[data-gallery-prev]');
    var galleryNextBtn = sectionEl.querySelector('[data-gallery-next]');

    function goSlide(idx) {
      var slides = modalSlides.querySelectorAll('.fs-shapes-modal__slide');
      if (!slides.length) return;
      currentSlide = Math.max(0, Math.min(idx, slides.length - 1));
      /* Ancora o deslocamento na posição real (em pixel inteiro) do slide ativo em vez de
         '%'. Com '%' a largura fracionária da galeria gera um offset com fração de pixel e
         o navegador rasteriza ~1px do slide vizinho na borda. offsetLeft já vem arredondado
         pelo layout, então a borda do slide ativo cai exata na origem e os vizinhos ficam
         clipados pelo overflow:hidden da galeria — sem seam. */
      modalSlides.style.transform = 'translateX(-' + slides[currentSlide].offsetLeft + 'px)';
      modalDots.querySelectorAll('[data-dot]').forEach(function (d) {
        d.classList.toggle('is-selected', parseInt(d.getAttribute('data-dot')) === currentSlide);
      });
      if (galleryPrevBtn) galleryPrevBtn.disabled = currentSlide === 0;
      if (galleryNextBtn) galleryNextBtn.disabled = currentSlide === slides.length - 1;
    }

    if (galleryPrevBtn) {
      galleryPrevBtn.addEventListener('click', function () {
        stopAutoplay();
        goSlide(currentSlide - 1);
      });
    }
    if (galleryNextBtn) {
      galleryNextBtn.addEventListener('click', function () {
        stopAutoplay();
        goSlide(currentSlide + 1);
      });
    }

    /* ── Navegação por gesto ── */
    var gallery = sectionEl.querySelector('[data-modal-gallery]');

    /* Touch (mobile) + mouse drag */
    var dragStartX = 0, dragStartY = 0, dragging = false;
    var DRAG_THRESHOLD = 40;

    function dragStart(x, y) {
      dragStartX = x; dragStartY = y; dragging = true;
    }
    function dragEnd(x, y) {
      if (!dragging) return;
      dragging = false;
      var dx = x - dragStartX;
      var dy = y - dragStartY;
      if (Math.abs(dx) > DRAG_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
        stopAutoplay();
        goSlide(dx < 0 ? currentSlide + 1 : currentSlide - 1);
      }
    }

    if (gallery) {
      /* Touch */
      gallery.addEventListener('touchstart', function (e) {
        dragStart(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        var t = e.changedTouches[0];
        dragEnd(t.clientX, t.clientY);
      }, { passive: true });

      /* Mouse drag */
      gallery.addEventListener('mousedown', function (e) {
        dragStart(e.clientX, e.clientY);
      });
      window.addEventListener('mouseup', function (e) {
        if (dragging) dragEnd(e.clientX, e.clientY);
      });

      /* Trackpad — scroll horizontal de dois dedos */
      var wheelLock = false;
      gallery.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return; /* só horizontal */
        e.preventDefault();
        if (wheelLock) return;
        if (Math.abs(e.deltaX) < 20) return;
        wheelLock = true;
        stopAutoplay();
        goSlide(e.deltaX > 0 ? currentSlide + 1 : currentSlide - 1);
        setTimeout(function () { wheelLock = false; }, 500);
      }, { passive: false });
    }

    function startAutoplay(data) {
      stopAutoplay();
      if (data && !data.autoplay) return;
      var slides = modalSlides.querySelectorAll('.fs-shapes-modal__slide');
      if (slides.length < 2) return;
      var ms = (data && data.autoplay_speed) ? data.autoplay_speed : currentAutoplayMs;
      autoplayTimer = setInterval(function () {
        var next = (currentSlide + 1) % slides.length;
        goSlide(next);
      }, ms);
    }

    function stopAutoplay() {
      if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
    }

    /* Pausa no hover */
    if (modal) {
      modal.addEventListener('mouseenter', stopAutoplay);
      modal.addEventListener('mouseleave', function () {
        if (!modal.hidden) startAutoplay(allModels[currentIndex]);
      });
    }

    function openModal(blockIndex) {
      var list = visibleModels();
      var pos  = list.findIndex(function (m) { return m.index === blockIndex; });
      if (pos === -1) pos = 0;
      currentIndex = pos;
      lastFocused = document.activeElement;
      renderModal(list[pos]);
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      /* Move o foco para o modal (a11y) */
      if (typeof modal.focus === 'function') modal.focus();
      startAutoplay(list[pos]);
    }

    /**
     * Ativa a tab de um índice, atualizando estados ARIA e foco.
     * @param {NodeList} links - tab-links
     * @param {NodeList} panes - tab-contents
     * @param {number} idx - índice alvo
     * @param {boolean} focus - se deve mover o foco para a tab ativada
     */
    function activateTab(container, links, panes, idx, focus) {
      links.forEach(function (l) {
        var on = l.getAttribute('data-tab') === String(idx);
        l.classList.toggle('current', on);
        l.setAttribute('aria-selected', String(on));
        l.setAttribute('tabindex', on ? '0' : '-1');
        if (on && focus) l.focus();
      });
      panes.forEach(function (p) { p.classList.remove('current'); p.hidden = true; });
      var pane = container.querySelector('.tab-content-' + idx);
      if (pane) { pane.classList.add('current'); pane.hidden = false; }
    }

    function initTabs(container) {
      var links = container.querySelectorAll('.tab-link');
      var panes = container.querySelectorAll('.tab-content');
      links.forEach(function (link, i) {
        link.addEventListener('click', function () {
          activateTab(container, links, panes, parseInt(link.getAttribute('data-tab')), false);
        });
        /* Teclado: Enter/Espaço ativam; setas navegam (padrão WAI-ARIA tabs) */
        link.addEventListener('keydown', function (e) {
          var idx = i;
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            activateTab(container, links, panes, parseInt(link.getAttribute('data-tab')), false);
          } else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            idx = (i + 1) % links.length;
            activateTab(container, links, panes, parseInt(links[idx].getAttribute('data-tab')), true);
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            idx = (i - 1 + links.length) % links.length;
            activateTab(container, links, panes, parseInt(links[idx].getAttribute('data-tab')), true);
          }
        });
      });
    }

    function renderModal(data) {
      if (!data) return;
      renderSlides(data.images, data.name);
      modalTitle.textContent = data.name || '';
      modalTitle.className   = 'fs-shapes-modal__title ' + (data.heading_size || 'heading-large');
      modalMeas.innerHTML    = buildMeasurements(data);
      modalTabs.innerHTML    = buildTabs(data);
      modalCta.innerHTML     = buildCta(data);
      initTabs(modalTabs);

      var list = visibleModels();
      modalPrev.disabled = currentIndex <= 0;
      modalNext.disabled = currentIndex >= list.length - 1;

      /* Volta ao topo ao trocar de model — sem isso a info herda a posição de scroll do
         model anterior. Zera os dois elementos roláveis (info no desktop, painel no mobile). */
      if (modalInfo) modalInfo.scrollTop = 0;
      if (modalPanel) modalPanel.scrollTop = 0;
    }

    function closeModal() {
      stopAutoplay();
      modal.hidden = true;
      document.body.style.overflow = '';
      /* Devolve o foco ao elemento que abriu o modal (a11y) */
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      lastFocused = null;
    }

    sectionEl.querySelectorAll('[data-card-open]').forEach(function (el) {
      el.addEventListener('click', function () {
        openModal(parseInt(el.getAttribute('data-card-open')));
      });
      /* Card é interativo: ativar por teclado também */
      el.setAttribute('tabindex', '0');
      el.setAttribute('role', 'button');
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openModal(parseInt(el.getAttribute('data-card-open')));
        }
      });
    });

    sectionEl.querySelectorAll('[data-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    if (modalPrev) {
      modalPrev.addEventListener('click', function () {
        if (currentIndex > 0) {
          currentIndex--;
          renderModal(visibleModels()[currentIndex]);
        }
      });
    }

    if (modalNext) {
      modalNext.addEventListener('click', function () {
        var list = visibleModels();
        if (currentIndex < list.length - 1) {
          currentIndex++;
          renderModal(list[currentIndex]);
        }
      });
    }

    /* Sticky: ajusta top ao header */
    var filterBar = sectionEl.querySelector('[data-filter-bar]');
    function setFilterTop() {
      var header = document.querySelector('[data-site-header], .header-wrapper, header[role]');
      if (header && filterBar) filterBar.style.top = header.getBoundingClientRect().height + 'px';
    }
    setFilterTop();
    window.addEventListener('resize', setFilterTop);

    /* ── Customizer: abre modal ao selecionar bloco ── */
    document.addEventListener('shopify:block:select', function (e) {
      if (!e.target || !sectionEl.contains(e.target)) return;
      var blockId = e.target.getAttribute('data-block-id');
      if (!blockId) return;
      var model = allModels.find(function (m) { return m.id === blockId; });
      if (!model) return;
      currentIndex = visibleModels().findIndex(function (m) { return m.id === blockId; });
      if (currentIndex < 0) currentIndex = 0;
      renderModal(model);
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      if (!e.target || !sectionEl.contains(e.target)) return;
      closeModal();
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.fs-shapes-guide[data-section-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Customizer: re-inicializa ao recarregar a section */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
